import React from "react";
import { DeleteButton, useNotify, useRedirect, useRecordContext } from "react-admin";
import firebaseDataProvider from "../../providers/dataProvider";

const CateogryDeleteButton = () => {
  const record = useRecordContext();
  const notify = useNotify();
  const redirect = useRedirect();

  if (!record) return null;

  // onSuccess callback after deleting the category record
  const handleOnSuccess = async (data: any) => {
    try {
      // Use the record's id (or an override id stored on the record) to delete the associated override document.
      await firebaseDataProvider.delete("sync/override/extra", { id: record.id });
      notify("Associated override document deleted", { type: "info" });
    } catch (error) {
      console.error("Error deleting override document:", error);
      notify("Failed to delete associated override document", { type: "warning" });
    }
    // Redirect back to the list view of categories.
    redirect("list", "categories");
  };

  return (
    <DeleteButton
      record={record}
      mutationOptions={{ onSuccess: handleOnSuccess }}
    />
  );
};

export default CateogryDeleteButton;
